import { ReleaseType } from '@logio/common-be-fe';
import { getPath } from '@logio/common-fe';
import React from 'react';
import { PagePathsEnum } from '../../shared/localization/PagePathsEnum';
import ReleaseNewPage from './ReleaseNewPage';

export default function SelloutReleaseNewPage() {
    return <ReleaseNewPage releaseTypes={[ReleaseType.Sellout]} backButtonPath={getPath(PagePathsEnum.ReleasesSellout)} />;
}
